import { Offcanvas, Form, Row, Col, InputGroup, Button } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';

const FilterTasksOffcanvas = ({ 
    show, 
    onHide,
    taskNameFilter,
    setTaskNameFilter,
    projectFilter,
    setProjectFilter,
    taskListFilter,
    setTaskListFilter,
    assigneeFilter,
    setAssigneeFilter,
    dueDateRange,
    setDueDateRange,
    priorityFilter,
    setPriorityFilter,
    stageFilter,
    setStageFilter,
    projectOptions,
    taskListOptions,
    assigneeOptions,
    priorityOptions,
    stageOptions
}) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Filter Tasks</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                <Form>
                    <Row className='gy-2'>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Task Name</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    value={taskNameFilter}
                                    onChange={(e) => setTaskNameFilter(e.target.value)}
                                    placeholder="Search tasks..."
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Project</Form.Label>
                                <Select
                                    value={projectFilter}
                                    onChange={setProjectFilter}
                                    options={projectOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Task List</Form.Label>
                                <Select
                                    value={taskListFilter}
                                    onChange={setTaskListFilter}
                                    options={taskListOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                    isDisabled={!projectFilter}
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Assignees</Form.Label>
                                <Select
                                    value={assigneeFilter}
                                    onChange={setAssigneeFilter}
                                    options={assigneeOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Due Date Range</Form.Label>
                                <InputGroup>
                                    <Flatpickr
                                        value={dueDateRange[0]}
                                        onChange={([date]) => setDueDateRange([date, dueDateRange[1]])}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            maxDate: dueDateRange[1] || 'today',
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                        }}
                                        placeholder="Start date"
                                    />
                                    <InputGroup.Text className="bg-light p-tag">to</InputGroup.Text>
                                    <Flatpickr
                                        value={dueDateRange[1]}
                                        onChange={([date]) => setDueDateRange([dueDateRange[0], date])}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            maxDate: 'today',
                                            minDate: dueDateRange[0],
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                        }}
                                        placeholder="End date"
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Priority</Form.Label>
                                <Select
                                    value={priorityFilter}
                                    onChange={setPriorityFilter}
                                    options={priorityOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Stage</Form.Label>
                                <Select
                                    value={stageFilter}
                                    onChange={setStageFilter}
                                    options={stageOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className="p-3 border-top">
                <div className="d-flex justify-content-between">
                    <Button variant="link" className='text-decoration-none' onClick={() => {
                        setTaskNameFilter('');
                        setProjectFilter(null);
                        setTaskListFilter(null);
                        setAssigneeFilter([]);
                        setDueDateRange([null, null]);
                        setPriorityFilter(null);
                        setStageFilter(null);
                    }}>
                        Reset
                    </Button>
                    <Button variant="primary" onClick={onHide}>
                        Apply Filters
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};

export default FilterTasksOffcanvas;
